export default "__VITE_ASSET__DQE$tAoW__"